module.exports = __webpack_public_path__ + "static/media/JamesLeeOp.6028f3e1.png";